// assets/rec-wizard.js
(function () {
  // Initialize all instances on the page
  function initAll() {
    document.querySelectorAll('.sb-rec-wizard').forEach(initWizard);
  }

  // Polyfill CSS.escape for older browsers
  if (!window.CSS) window.CSS = {};
  if (typeof window.CSS.escape !== 'function') {
    window.CSS.escape = function (value) {
      return String(value).replace(/[^a-zA-Z0-9_-]/g, function (ch) {
        var hex = ch.charCodeAt(0).toString(16).toUpperCase();
        return '\\' + hex + ' ';
      });
    };
  }

  function initWizard(root) {
    if (!root || root.dataset.enhanced === '1') return;
    root.dataset.enhanced = '1';

    const form = root.querySelector('form.sb-form');
    const steps = Array.from(root.querySelectorAll('.sb-step'));
    const progressBar = root.querySelector('.sb-progress-bar');
    const progressLabel = root.querySelector('.sb-progress-label');
    const templateActions = root.querySelector('.sb-actions--template');
    const compiled = root.querySelector('#sb-compiled');

    function makeActions() {
      const wrap = document.createElement('div');
      wrap.className = 'sb-actions';
      wrap.innerHTML = '<button type="button" class="sb-back">Back</button><button type="button" class="sb-next">Next</button>';
      return wrap;
    }

    // Inject Next/Back into each step except last
    steps.forEach((step, i) => {
      step.setAttribute('aria-current', i === 0 ? 'step' : 'false');
      if (i < steps.length - 1) {
        if (!step.querySelector('.sb-actions:not(.sb-actions--template)')) {
          let actions = templateActions ? templateActions.cloneNode(true) : makeActions();
          if (templateActions) {
            actions.classList.remove('sb-actions--template');
            actions.removeAttribute('aria-hidden');
          }
          step.appendChild(actions);
        }
      }
    });

// Make step 1 current; rely on CSS to show/hide
if (steps[0]) {
  steps[0].removeAttribute('style'); // undo any old inline display from previous versions
  steps[0].setAttribute('aria-current', 'step');
}

    // Pull order number from ?order=12345
    const params = new URLSearchParams(location.search);
    const orderField = root.querySelector('#sb-order-number');
    if (orderField && params.get('order')) orderField.value = params.get('order');

    function getValue(name) {
      const nodes = Array.from(form.querySelectorAll('[name="' + CSS.escape(name) + '"]'));
      if (!nodes.length) return null;
      const type = nodes[0].type;
      if (type === 'radio') {
        const chosen = nodes.find(n => n.checked);
        return chosen ? chosen.value : null;
      }
      if (type === 'checkbox') {
        return nodes.filter(n => n.checked).map(n => n.value);
      }
      return nodes[0].value;
    }

    function evalConditions() {
      root.querySelectorAll('[data-show-if]').forEach(box => {
        const rule = box.getAttribute('data-show-if');
        if (!rule) return;
        const idx = rule.indexOf(':');
        if (idx === -1) return;
        const field = rule.slice(0, idx).trim();
        const allowed = rule.slice(idx + 1).split(',').map(s => s.trim());
        const current = getValue(field);
        let show = false;
        if (Array.isArray(current)) show = current.some(v => allowed.includes(v));
        else show = current && allowed.includes(current);
        box.hidden = !show;
        if (!show) {
          box.querySelectorAll('input, select, textarea').forEach(el => {
            if (el.type === 'checkbox' || el.type === 'radio') el.checked = false;
            else if (el.tagName === 'SELECT') el.selectedIndex = 0;
            else el.value = '';
          });
        }
      });
    }

    if (form) {
      form.addEventListener('change', e => {
        evalConditions();
        const wrap = e.target.closest('[data-max]');
        if (wrap) {
          const max = parseInt(wrap.dataset.max || '99', 10);
          const checks = wrap.querySelectorAll('input[type="checkbox"]:checked');
          if (checks.length > max) {
            e.target.checked = false;
            const note = document.createElement('div');
            note.className = 'sb-max-note';
            note.style.cssText = 'color:#b91c1c;margin-top:.25rem;font-size:.85rem;';
            note.textContent = 'Pick up to ' + max + '.';
            wrap.appendChild(note);
            setTimeout(() => note.remove(), 1600);
          }
        }
      });
      form.addEventListener('input', evalConditions);
    }

    // Stepper
    let index = 0;
    function visibleSteps() { return steps.filter(s => !s.hidden); }
    function nextIndex(from, dir) {
      let j = from + dir;
      while (j >= 0 && j < steps.length && steps[j].hidden) j += dir;
      return Math.max(0, Math.min(j, steps.length - 1));
    }
    function go(i) {
      i = Math.max(0, Math.min(i, steps.length - 1));
      while (i < steps.length - 1 && steps[i].hidden) i++;
      index = i;
      steps.forEach((s, n) => s.setAttribute('aria-current', n === index ? 'step' : 'false'));
      const vis = visibleSteps();
      const visIndex = Math.max(0, vis.indexOf(steps[index]));
      const total = Math.max(1, vis.length);
      const pct = total > 1 ? Math.round((visIndex / (total - 1)) * 100) : 100;
      if (progressBar) progressBar.style.setProperty('--pct', pct + '%');
      if (progressLabel) progressLabel.textContent = 'Step ' + (visIndex + 1) + ' of ' + total;
      const first = steps[index].querySelector('input, select, textarea, button');
      if (first) first.focus({ preventScroll: true });
    }
    root.addEventListener('click', e => {
      if (e.target.matches('.sb-next')) { if (validateStep(index)) go(nextIndex(index, +1)); }
      if (e.target.matches('.sb-back')) { go(nextIndex(index, -1)); }
    });

    function validateStep(i) {
      const step = steps[i];
      const requireds = step.querySelectorAll('[required]');
      for (const el of requireds) {
        if (el.type === 'radio') {
          const group = step.querySelectorAll('input[name="' + el.name + '"]');
          const chosen = Array.from(group).some(n => n.checked);
          if (!chosen) { group[group.length - 1].focus(); return false; }
        } else if (!el.value) { el.focus(); return false; }
      }
      return true;
    }

    if (form) {
      form.addEventListener('submit', () => {
        const data = {};
        const elements = Array.from(form.elements).filter(el => el.name && !el.closest('.sb-actions--template'));
        for (const el of elements) {
          if (el.name === 'contact[body]' || el.type === 'submit' || el.type === 'button') continue;
          if (el.closest('[hidden]')) continue;
          let label = '';
          const field = el.closest('.sb-field');
          if (field) {
            const question =
              field.querySelector(':scope > label') ||
              field.querySelector('.sb-label');
            if (question)
              label = question.textContent.trim();
          }
          if (!label)
            label = el.dataset.label || el.name;
          if (el.type === 'checkbox') {
            if (!el.checked) continue;
            (data[label] ||= []).push(el.value);
          } else if (el.type === 'radio') {
            if (!el.checked) continue;
            data[label] = el.value;
          } else {
            if (el.value) data[label] = el.value;
          }
        }
        const summary = Object.entries(data)
          .map(([k, v]) => {
            if (Array.isArray(v)) {
               return k +
                 '\n' +
                 v.join('\n');
            }
            return k +
              '\n' +
               v;
            })
          .join('\n');
        compiled.value = 'Recommendation questionnaire\n\n' + summary;
      }, { once: true });
    }

    // Start
    evalConditions();
    go(0);
  }

  // Run on page load and when sections are reloaded in the Theme Editor
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    e.target && e.target.querySelectorAll && e.target.querySelectorAll('.sb-rec-wizard').forEach(initWizard);
  });
})();
